/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-async-promise-executor */
import { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  doLogIn,
  doUpdateUser,
  doLogOut,
  doCheckSession,
  doSaveFilter,
  doEditFilter,
  doDeleteFilter,
  doGetFilters,
  doExtendSession,
  cleanErrors as cleanErrorsAuth,
  cleanstate as cleanStateAuth
} from '@/store/auth/auth-actions';

import {
  fetchAllocations,
  fetchProfessionals,
  fetchEngagements
} from '@/store/scheduling/scheduling-actions';

const useRedux = () => {
  const dispatch = useDispatch();

  const AUTHENTICATION = {
    login(username, password) {
      return new Promise(async (resolve, reject) => {
        const res = await doLogIn(dispatch, username, password);
        resolve(res);
      });
    },
    updateUser(id, updatedFields) {
      return new Promise(async (resolve, reject) => {
        const res = await doUpdateUser(dispatch, id, updatedFields);
        resolve(res);
      });
    },
    logout() {
      doLogOut(dispatch);
      cleanStateAuth(dispatch);
    },
    checkSession() {
      doCheckSession(dispatch);
    },
    extendSession() {
      return new Promise(async (resolve, reject) => {
        const res = await doExtendSession(dispatch);
        resolve(res);
      });
    },
    saveFilter(userId, name, filter) {
      doSaveFilter(dispatch, userId, name, filter);
    },
    editFilter(userId, previousName, updatedName, filter) {
      doEditFilter(dispatch, userId, previousName, updatedName, filter);
    },
    deleteFilter(userId, name) {
      doDeleteFilter(dispatch, userId, name);
    },
    getFilters(userId) {
      doGetFilters(dispatch, userId);
    },
    getAuthData() {
      const authState = useSelector(state => state.auth); // Redux state
      const isLoggedIn = authState.isLoggedIn || localStorage.getItem('isLoggedIn') === 'true'; // Check persistent storage
      const name = localStorage.getItem('name');
      const id = localStorage.getItem('id');
      const role = localStorage.getItem('role');
      const timeout = localStorage.getItem('timeout');
      return { ...authState, isLoggedIn, name, role, id, timeout };
    }
  };

  const SCHEDULING = {
    getSchedulingState() {
      return useSelector(state => state.scheduling);
    },
    setAllocationsData() {
      return new Promise(async (resolve, reject) => {
        const res = await fetchAllocations(dispatch);
        resolve(res);
      });
    },
    setProfessionalsData() {
      return new Promise(async (resolve, reject) => {
        const res = await fetchProfessionals(dispatch);
        resolve(res);
      });
    },
    setEngagementsData() {
      return new Promise(async (resolve, reject) => {
        const res = await fetchEngagements(dispatch);
        resolve(res);
      });
    }

  }

  const SHARED = {
    cleanErrors() {
      cleanErrorsAuth(dispatch);
    }
  };
  const actions = useMemo(
    () => ({
      ...SHARED,
      ...AUTHENTICATION,
      ...SCHEDULING
        }),
    []
  );

  return actions;
};

export default useRedux;
